import { DocumentosOficialesService } from './documentos-oficiales.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ArrowBackComponent } from 'app/modules/GlobalComponents/arrow-back.component';
import { map, Observable, Subject, takeUntil } from 'rxjs';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { Tipologia } from 'app/models/tipologias.model';
import { environment as env } from 'environments/environments';
import { MatSelectModule } from '@angular/material/select';
import { StatusStickerComponent } from 'app/modules/GlobalComponents/status sticker.component';
import { CONSTANTS } from 'app/core/constants';
import { DocumentoGenerado, DocumentosGeneradosResponse } from '../../bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/models/response-documento-generado';
import { FilterParamsDocumentosGenerados } from '../models/filter-params-documentos';

@Component({
    selector: 'documentos-ofiales',
    templateUrl: 'documentos-oficiales.component.html',
    imports:[
        CommonModule,
        ArrowBackComponent, 
        MatTableModule,
        MatIconModule,
        MatButtonModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatSelectModule,

        StatusStickerComponent,
    ]
})

export class DocumentosOficialesComponent implements OnInit {
    documentos$: Observable<DocumentosGeneradosResponse>
    documentoCertificados$: Observable<DocumentoGenerado[]>

    tableColumns:string[]=['id','tipoDocumento', 'seccion', 'estado', 'fechaGeneracion', 'vencimiento', 'link']
    paramsDocumentos:Partial<FilterParamsDocumentosGenerados>
    dataSource:DocumentoGenerado[]=[]
    secciones:Tipologia[]

    tipology_seccion:number = env.TIPOLOGIA_PADRE_ID_SECCION
    todas:number= 0

    //paginador
    @ViewChild(MatPaginator) paginator: MatPaginator;
    pageSizes = 10
    inicio:number = 0
    max:number = 10
    totalItems:number

    _unsubscribe: Subject<any> = new Subject()

    constructor(
        private _documentosOficialesService:DocumentosOficialesService,
        private router: Router
    ) { 
        this.paramsDocumentos = {inicio:0, max:10, status:CONSTANTS.ID_ESTADO_CERTIFICADO};
        this._documentosOficialesService.documentosOficialesFilterParmas = this.paramsDocumentos

        this.getDocumentosGenerados(this.paramsDocumentos)
        this.getSeccion()

        this.documentos$=  this._documentosOficialesService.ListaDocumentosGenerados$

        this.documentos$.pipe(takeUntil(this._unsubscribe))
            .subscribe(documentos => {
                this.totalItems = documentos?.total;
                this.dataSource= documentos?.data
            });
        
    }

    ngOnInit() { 
        
    }

    ngAfterViewInit():void {
        this.paginator.page
            .pipe(takeUntil(this._unsubscribe))
            .subscribe(event => {
                const startIndex = event.pageIndex * event.pageSize;
                const endIndex = startIndex + event.pageSize;
                this.inicio = startIndex;
                this.max = endIndex;

                const filters= this._documentosOficialesService.documentosOficialesFilterParmasValue;
                console.log('filters', filters);
                if(filters){
                    const newParams={
                        ... filters,
                        inicio: this.inicio,
                        max: this.max,  
                    }
                    this.getDocumentosGenerados(newParams);
                }else{
                    const newParams:FilterParamsDocumentosGenerados = {
                        inicio: this.inicio,
                        max: this.max,
                    };
                    this.getDocumentosGenerados(newParams);
                }


                
            });
    }

    getDocumentosGenerados(params: FilterParamsDocumentosGenerados){
        
        this._documentosOficialesService.getListaDocumentosOficiales(params)
    }

    abrirDetalleDocumento(documento_uuid:string){
        this.router.navigateByUrl(`documentos-oficiales/detalle/${documento_uuid}`)
    }

    getSeccion() {
        this._documentosOficialesService.getTipologias(this.tipology_seccion)
            .then((response: Tipologia[]) => {
                this.secciones = response;
        });
    }

    filtrar(){
        const paramsLimpios = this.limpiarParametros(this.paramsDocumentos);

        this.getDocumentosGenerados(paramsLimpios);
        this._documentosOficialesService.documentosOficialesFilterParmas = this.paramsDocumentos
    }

    limpiarParametros(params: any): any {
        const paramsFiltrados: any = {};
        Object.keys(params).forEach(key => {
            const valor = params[key];
            if (valor !== null && valor !== undefined && valor !== '') {
            paramsFiltrados[key] = valor;
            }
        });
        return paramsFiltrados;
    }

    ngOnDestroy() {
        this._unsubscribe.next(null);
        this._unsubscribe.complete();
    }
}